import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { type NotificationTemplateResource } from "@exonn/js-sdk";

export const module: ModuleOptions<NotificationTemplateResource> = {
  resource: ResourceEnum.NotificationSignature,
  bigIcon: <span className={"icon-20-email_sgntr"} />,
  smallIcon: <span className={"icon-15-email_sgntr"} />,
};
